var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { staticClass: "flex", class: _vm.optionClasses }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "flex items-center" }, [
        _c("span", { staticClass: "font-medium text-gray-900" }, [
          _vm._v(_vm._s(_vm.displayName)),
        ]),
        _vm.option.client_id
          ? _c(
              "span",
              {
                staticClass:
                  "ml-2 text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded",
              },
              [_vm._v(" " + _vm._s(_vm.option.client_id) + " ")]
            )
          : _vm._e(),
      ]),
      _vm.hasSecondaryInfo
        ? _c("div", { staticClass: "text-xs text-gray-600 mt-1" }, [
            _vm.preferredNameDifferent
              ? _c("span", { staticClass: "italic" }, [
                  _vm._v("Preferred: " + _vm._s(_vm.option.preferred_name)),
                ])
              : _vm._e(),
            _vm.contactInfo
              ? _c("span", { class: _vm.preferredNameDifferent && "ml-3" }, [
                  _vm._v(_vm._s(_vm.contactInfo)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }